import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Subject } from 'rxjs';

import { TIYWidgetContainer } from '../../private/containers/TIYWidgetContainer/TIYWidgetContainer';
import { lePlaygroundContext } from '../../private/global-constants';
import { Container } from '../../../symphony';

import s from './SlTIYWidgetPlayground.scss';
import { SlActionsService } from '../../private/services/ActionsService/sl-actions.service';
import { PlaygroundContainer } from '../../private/containers/PlaygroundContainer/PlaygroundContainer';
import { ModalsWrapper } from '../../private/components/Modals/ModalsWrapper';

export function SlTIYWidgetPlayground(props) {
	useStyles(s);

	const [isReady, setIsReady] = useState<boolean>(false);

	useEffect(() => {
		const unsubscriber = new Subject<void>();
		const {
			solveMaterialCallback, errorHandler, materialInfo: { header: { materialRelationId } }, soloLearnUrl, alias, lessonSessionGuId,
		} = props;

		lePlaygroundContext.setValue(`aIChatPlaygroundContext_${materialRelationId}_${lessonSessionGuId}`);

		Container.register(lePlaygroundContext.value, 'unsubscriber', unsubscriber);

		Container.register(lePlaygroundContext.value, 'isTryItYourself', true);

		Container.register(lePlaygroundContext.value, 'errorHandler', errorHandler);

		Container.register(
			lePlaygroundContext.value,
			'materialId',
			materialRelationId,
		);

		Container.register(
			lePlaygroundContext.value,
			'solveMaterialCallback',
			solveMaterialCallback,
		);

		Container.register(
			lePlaygroundContext.value,
			'isTIYWidget',
			true,
		);

		Container.register(
			lePlaygroundContext.value,
			'soloLearnUrl',
			soloLearnUrl,
		);

		Container.register(
			lePlaygroundContext.value,
			'courseAlias',
			alias,
		);
		Container.take(lePlaygroundContext.value, SlActionsService);

		setIsReady(true);

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	return (isReady
		? (
			<div className="sl-tiy-widget-playground">
				<TIYWidgetContainer {...props} />
				<PlaygroundContainer {...props} />
				<ModalsWrapper />
			</div>
		) : null
	);
}
